export default {
	gtag_id: 'UA-75984265-2',
	gtag_id_dev: 'UA-75984265-4',
	a2a_global_endpoint: 'https://vpad.app2app.mobi:8443',
	a2a_session_prefix: 'EVAS',
	a2a_cors_prefix: 'https://cors-anywhere.vbote.com/',
	online_test_endpoint: 'https://flowhomework.turningtechnologies.com/',
    version: '1.0.62'
};
